import { useQueryClient } from '@tanstack/react-query';

import type { AdminUser } from '../../entities/entityTypes';
import { requestBuilder } from '../../http/RequestBuilder';
import { type UpdateAdminUserDto } from '../types/AdminUserTypes';

const useUpdateAdminUser = requestBuilder.mutation<
    AdminUser,
    UpdateAdminUserDto,
    Pick<AdminUser, 'id'>
>({
    endpoint: ({ id }) => `/api/admin/admin-user/${id}`,
    method: 'PATCH',
});

export const useUpdateAdminUserAndRefetch = () => {
    const queryClient = useQueryClient();

    const { mutateAsync } = useUpdateAdminUser({
        onMutate: async () => {},
        onSuccess: async () => {
            await queryClient.invalidateQueries({
                queryKey: ['getAllAdminUsers'],
                exact: true,
            });
        },
        onSettled: () => {},
    });

    const updateAdminUserAsync = async (
        id: string,
        body: UpdateAdminUserDto,
    ) => {
        return await mutateAsync({
            urlParams: {
                id,
            },
            body,
        });
    };

    return {
        updateAdminUserAsync,
    };
};
